module.exports = __webpack_public_path__ + "website/img/saas-3.ff0184c2.png";